import useRecruitmentSpec from '../../api/useRecruitmentSpec';
import { useCandidatesOverviewContext } from '../Contexts/CandidatesOverviewContext/CandidatesOverviewContext';
import CandidatesOverviewNavigationSidebar from '@/Components/CandidatesOverview/CandidatesOverviewNavigationSidebar';
import useCompanyId from '@/Hooks/UseCompanyId';

const CandidatesOverviewPageNavigationSidebar = () => {
    const { assessmentId, clientId, tabValue, handleTabChange } = useCandidatesOverviewContext();
    const { data: recruitmentSpec } = useRecruitmentSpec(assessmentId);
    const companyId = useCompanyId();

    return (
        <CandidatesOverviewNavigationSidebar
            clientId={clientId || ''}
            companyId={companyId}
            recruitmentName={recruitmentSpec?.name}
            jobLocation={recruitmentSpec?.jobLocation}
            isAgenticSearchSelected={false}
            isIdentifiedAiSearchSelected={false}
            isShortlistedAiSearchSelected={false}
            selectedApplicantOverviewTab={tabValue}
            handleApplicantOverviewTabChange={handleTabChange}
        />
    );
};

export default CandidatesOverviewPageNavigationSidebar;
